<template>
  <div id="commercial" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo">Empresa Comercial</v-row>
      <v-row no-gutters class="datos">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="mt-11 mb-2"
        >
          <div class="form-group inputEnterprise">
            <label for="rs" style="width: 10% !important; margin-left: -0.1%"
              >Razón Social</label
            >
            <input
              type="text"
              name="rs"
              id="rs"
              v-model="reason"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="rfc">RFC</label>
            <input
              type="text"
              name="rfc"
              id="rfc"
              v-model="rfc"
              maxlength="12"
              minlength="12"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="imss">IMSS</label>
            <input
              type="text"
              name="imss"
              id="imss"
              v-model="imss"
              minlength="11"
              maxlength="11"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-5"
          >Domicilio</v-col
        >

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="pais">País</label>
            <input
              type="text"
              name="pais"
              id="pais"
              v-model="country"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="cp">C.P.</label>
            <input
              type="text"
              name="cp"
              id="cp"
              maxlength="5"
              v-model="cp"
              @keypress="isNumber($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="estado">Estado</label>
            <input
              type="text"
              name="estado"
              id="estado"
              v-model="state"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="municipio">Municipio</label>
            <input
              type="text"
              name="municipio"
              id="municipio"
              v-model="municipality"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="colonia">Colonia</label>
            <input
              type="text"
              name="colonia"
              id="colonia"
              v-model="suburb"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group inputEnterprise">
            <label for="calle" style="margin-left: 1%; width: 10%">Calle</label>
            <input
              type="text"
              name="calle"
              id="calle"
              v-model="street"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="ne">N° Exterior</label>
            <input
              type="text"
              name="ne"
              id="ne"
              v-model="exterior"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label for="ni">N° Interior</label>
            <input
              type="text"
              name="ni"
              id="ni"
              v-model="interior"
              @keypress="alfaNumerico($event)"
              readonly
            />
          </div>
        </v-col>

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterprise">
            <label>Logotipo</label>
            <label for="log" class="custom-file-upload">Seleccionar</label>
            <input
              type="file"
              name="log"
              id="log"
              class="inputs"
              @change="onFileChange($event)"
            />
          </div>
        </v-col>
        <v-col
          class="pb-0"
          cols="12"
          xs="6"
          sm="6"
          md="6"
          lg="6"
          xl="6"
          justify="center"
          id="previewRow"
        >
          <v-row align-content="center" justify="center">
            <img
              id="preview"
              v-if="url"
              :src="url"
              alt="Logotipo"
              style="max-width: 300px !important; max-height: 150px !important"
            />
          </v-row>
        </v-col>

        <v-col>
          <div class="form-group text-center terminos mt-4">
            <div class="mb-5">
              <input
                type="checkbox"
                value="terminos"
                v-model="check"
                @click="check = true"
              />
              <label for="terminos" class="terminos"
                >Es la empresa pagadora</label
              >
              <br />
            </div>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Siguiente
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!--Error-->
    <v-dialog v-model="error" width="450">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Empresa Pagadora</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "3-N",
      show: false,
      check: false,
      error: false,
      errors: [],
      respuesta: "",
      reason: "Empresa Comercial Abastecedor S.A. de C.V.",
      imss: "1515JLOP",
      rfc: "ABS900715MX0",
      country: "Mexico",
      cp: "56576",
      state: "Mexico",
      municipality: "Ixtapaluca",
      suburb: "Estado de Mexico",
      street: "Ixtapaluca",
      exterior: "4",
      interior: "13",
      url: "",
      selectedFile: "",
    };
  },
  methods: {
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-Z0-9 ]+$"); // Letras y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
      } else return true;
    },
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validacion() {
      this.errors = [];
      if (this.errors.length == 0) {
        this.siguiente();
      } else {
        this.respuesta = "Por favor corriga los siguientes errores:";
        this.error = true;
      }
    },
    siguiente() {
      if (this.check) {
        var data = new FormData();
        data.append("RazonSocial", this.reason);
        data.append("NSS", this.imss);
        data.append("RFC", this.rfc);
        data.append("Pais", this.country);
        data.append("CodigoPostal", this.cp);
        data.append("AsentamientoId", this.suburb);
        data.append("NumeroExterior", this.exterior);
        data.append("NumeroInterior", this.interior);
        data.append("Calle", this.street);
        data.append("EmpresaPagadora", this.check);
        if (this.selectedFile)
          data.append("Logo", this.selectedFile, this.selectedFile.name);
        console.log(
          "selecciono empresa pagadora entonces se agrega la empresa a empresa pagadora"
        );
        this.show = true;
        axios
          .post(Server + "/empresas", data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            localStorage.idCommercialEnterprise = response.data.id;
            this.show = false;
            this.$router.push("/branchs");
          })
          .catch((e) => {
            console.log(e);
            this.show = false;
            this.reason = "";
            this.imss = "";
            this.rfc = "";
            this.country = "";
            this.cp = "";
            this.state = "";
            this.municipality = "";
            this.suburb = "";
            this.exterior = "";
            this.interior = "";
            this.street = "";
            this.respuesta = "La Empresa no fue almacenada";
          });
      } else {
        localStorage.idCommercialEnterprise = "99999";
        this.show = false;
        this.$router.push("/addpaying");
      }
    },
    onFileChange(evt) {
      const file = evt.target.files[0];
      this.url = URL.createObjectURL(file);
      var fileBase = evt.target.files[0];
      this.selectedFile = file;
      var reader = new FileReader();
      reader.onloadend = function () {
        console.log("RESULT", reader.result);
        sessionStorage.setItem("base64img", reader.result);
      };
      reader.readAsDataURL(fileBase);
    },
    validaImss() {
      var imss = this.imss;
      if (imss.length != 11) {
        this.errors.push("Número de IMSS incorrecto");
        return false;
      } else {
        return false;
      }
    },
    validaRfc() {
      var strCorrecta;
      strCorrecta = this.rfc;
      if (this.rfc.length == 12) {
        console.log("Correcto");
        return true;
      } else {
        this.errors.push("El RFC es incorrecto favor de verificarlo.");
        return false;
      }
    },
  },
  created() {
    sessionStorage.setItem("base64img", null);
    this.nombre();
  },
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
</style>
